import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { generateReturningUsersMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function ReturningUsersChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchReturningUsersMetrics = async () => {
            setLoading(true);
            const returningUsersMetrics = await generateReturningUsersMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!returningUsersMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch returning users metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Sort the data chronologically by month
            const sortedData = (returningUsersMetrics.chartData || []).sort((a, b) => {
                return a.month.localeCompare(b.month);
            });

            setData(sortedData);
        };
        fetchReturningUsersMetrics();
    }, [loginUser.jwtToken]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>New vs Returning Users</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis 
                                            dataKey="month" 
                                            angle={-45} 
                                            textAnchor="end" 
                                            height={70}
                                            tick={{fontSize: 12}}
                                        />
                                        <YAxis 
                                            label={{ 
                                                value: 'Users', 
                                                angle: -90, 
                                                position: 'insideLeft',
                                                style: { textAnchor: 'middle' }
                                            }}
                                        />
                                        <Tooltip />
                                        <Legend />
                                        <Line 
                                            type="monotone" 
                                            dataKey="newUsers" 
                                            name="New Users" 
                                            stroke="#01929b" 
                                            activeDot={{ r: 8 }} 
                                        />
                                        <Line 
                                            type="monotone" 
                                            dataKey="returningUsers" 
                                            name="Returning Users" 
                                            stroke="#f2736a" 
                                            activeDot={{ r: 8 }} 
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 